document.querySelectorAll(".abo-faq-list").forEach((detail) => {

    // initial state
    if (detail.open) {
        detail.classList.add("expanded");
    }

    const summary = detail.querySelector(".abo-faq-question");

    summary.addEventListener("click", (e) => {
        e.preventDefault();

        const isOpen = detail.open;
        const duration = 350;

        // sluit andere items
        document.querySelectorAll("details.expanded").forEach((item) => {
            if (item !== detail) {
                item.classList.remove("expanded");
                setTimeout(() => (item.open = false), duration);
            }
        });

        if (isOpen) {
            detail.classList.remove("expanded");
            setTimeout(() => (detail.open = false), duration);
        } else {
            detail.open = true;
            requestAnimationFrame(() => {
                detail.classList.add("expanded");
            });
        }
    });
});